module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-HIPPO-Earthquake.b7323dac.gif";